import React, { useEffect, useState } from 'react'
import { showLoader, removeLoader, showToast, TOAST_TYPE, DKLabel, INPUT_VIEW_DIRECTION, DKInput, isValidEmail, DKButton,showAlert } from 'deskera-ui-library';
import { INPUT_TYPE } from '../../constants/Constant';
import { COLUMN_CODE, TableManger, TABLES } from '../../managers/TableManger';
import UserService from '../../services/UserService';
import Table from '../../services/table';
import RouteManager, { PAGE_ROUTES } from '../../managers/RouteManager';
import Utility from '../../utility/Utility';
import MessageInfo from '../common/MessageInfo';
import { getCountryPhoneCode, isIndiaCompliance, isUSCompliance, showUserLimitExceedsAlert } from '../../managers/common/CommonUtil';
import i18next from 'i18next';
import PermissionUtils, { ACTION, MODULE } from '../user-permissions/PermissionUtils';
import { CompensationPeriod, CompensationPeriodMYSG, CompensationPeriodUS } from '../add-employee/steps/Employee';


const ShowAddEmployeePopup = (props) => {

    const compliancePeriods = isUSCompliance() ? CompensationPeriodUS : CompensationPeriodMYSG
    const periodType =  compliancePeriods.map(c=>c.name);

    const [employeeData, setEmpployeeData] = useState({})

    const [invalidField, setInvalidField] = useState({
        firstName: false,
        lastName: true,
        invalidMail: false,
        dupliacateContact: false,
        invalidContact: false,
    })

    useEffect(() => {
        setEmpployeeData(props.employeeData)
        checkDuplicateEmail(props.employeeData.emailId, props.employeeData.contact)
    }, [])


    const checkDuplicateEmail = (emailId, contact) => {
        let email = encodeURIComponent(emailId)
        let contactNum = encodeURIComponent(`${getCountryPhoneCode()}${contact}`)
        let params = {
            emailId: email,
            userId: ""
        };
        UserService.isEmailDuplicate(params).then((response) => {
            if (response && response["isdupliacateEmail"]) {
                invalidField.invalidMail = true

            } else {
                invalidField.invalidMail = false
            }

            setInvalidField({ ...invalidField })
        })
    }

    const saveEmployee = () => {

        for (const [key, value] of Object.entries(invalidField)) {
            if (value) {
                return
            }
        }

        showLoader("Adding employee, Please wait...")
        Table.saveEmployee(employeeData).then(
            (res) => {
                if (res && res.user && res.status != "FAILED") {
                    const { user } = res
                    const employeeId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.EMPLOYEE_ID);
                    const userId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.USER_ID);
                    const tableId = TableManger.getTableId(TABLES.CANDIDATE);


                    let cellParam = {
                        [employeeId]: res.user.employeeId,
                        [userId]: res.user.userId
                    }

                    Table.updateRecord(
                        cellParam,
                        props.selectedRow.id,
                        tableId
                    ).then((data) => {
                        removeLoader()
                        showToast(
                            i18next.t("SUCCESS_ADD_TO_EMPLOYEE"),
                            TOAST_TYPE.SUCCESS
                        );
                        props.onClose(true)
                    });

                } else {
                    if (!Utility.isEmpty(res['errors']) && (res['errors'][0]['code'] === 'UM_1002' || res['errors'][0]['code'] === 'UM_1003')) {
                        showUserLimitExceedsAlert();
                    } else {
                        showAlert("Error","Problem while adding candidate as a employee.");
                    }
                    removeLoader()
                }
            },
            (err) => {
                removeLoader()
                if(err && err.message) {
                    showAlert("Error",String(err.message));
                } else {
                    showToast(
                        "Some Unknown Error Occurred at Server.Please Try Again!",
                        TOAST_TYPE.FAILURE
                    );
                }
            }
        );
    }

    const getBannerMessageForEmployee = () => {
        let messageGroup = [{
            message: "Your employees will receive an email invite once you add them here. Please ask them to complete their profile before processing payroll.",
            isAction: false
        }];
        return messageGroup;
    }

    return (
        <div className="popup-window p-h-xl" style={{ maxWidth: 450 }}>

            <div className="parent-width">

                <div className="parent=width row mb-l">
                    <div style={{width :"74%"}}>
                        <DKLabel text="Add your employee" className="fw-m fs-xxl mt-l" />
                        <DKLabel text="Invite your employees to fill info" className="mt-s " style={{ opacity: "0.6" }} />
                    </div>
                    <div className="m-v-s d-flex" >
                        <DKButton
                            title="Cancel"
                            className="g-gray1 border-m"
                            onClick={(event) => {
                                props.onClose()
                            }}
                        />
                        <DKButton
                            title="Save"
                            className="border-m ml-r bg-app text-white"
                            onClick={() => saveEmployee()}
                        />

                    </div>
                </div>

                <MessageInfo
                    bannerClass={"mb-l"}
                    message={getBannerMessageForEmployee()}
                    isClosable={true}
                />

                <div className="row align-items-start mb-m">
                    <DKInput
                        value={employeeData['firstName']}
                        title="First Name"
                        className="mr-l"
                        type="text"
                        required={true}
                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                        canValidate={invalidField.firstName}
                        onChange={(value) => {
                            Utility.isEmpty(value) ? setInvalidField({ ...invalidField, firstName: true }) : setInvalidField({ ...invalidField, firstName: false })
                            employeeData['firstName'] = Utility.isEmpty(value) ?  " " : value.trim()

                        }
                        }
                    />
                    <DKInput
                        value={employeeData['lastName']}
                        title="Last Name"
                        type="text"
                        required={true}
                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                        canValidate={invalidField.lastName}
                        onChange={(value) => {
                            Utility.isEmpty(value) ? setInvalidField({ ...invalidField, lastName: true }) : setInvalidField({ ...invalidField, lastName: false })
                            employeeData['lastName'] = Utility.isEmpty(value) ?  " " : value.trim()

                        }
                        }
                    />
                </div>

                <div className="row mb-m" style={{ display: "block" }}>
                    <DKInput
                        value={employeeData['emailId']}
                        title="Email"
                        className="mr-l"
                        type="email"
                        required={true}
                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                        canValidate={true}
                        onChange={(value) => {
                            if (Utility.isValidEmail(value.trim())) {
                                checkDuplicateEmail(value.trim(), employeeData['contact'])
                            } else {
                                setInvalidField({ ...invalidField, invalidMail: false })
                            }
                            employeeData['emailId'] = Utility.isEmpty(value) ?  " " : value.trim()
                        }
                        }
                    />
                    {invalidField.invalidMail && (
                        <DKLabel
                            className="pl-s fs-s unselectable text-red"
                            style={{
                                whiteSpace: "nowrap",
                            }}
                            text={
                                "This email has already been taken."
                            }
                        />
                    )}
                </div>

                {PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT) &&
                    <div className="row align-items-start mt-s mb-m">
                        <DKInput
                            value={!isIndiaCompliance() ? employeeData['compensation']: employeeData['ctc']}
                            title={!isIndiaCompliance() ?i18next.t("BASIC_SALARY"):"CTC"}
                            type="number"
                            className="mr-l"
                            required={false}
                            direction={INPUT_VIEW_DIRECTION.VERTICAL}
                            onChange={(value) => {
                                if(isIndiaCompliance()) {
                                    employeeData['ctc'] = parseFloat(value, 10)
                                } else {
                                    employeeData['compensation'] = parseFloat(value, 10)
                                }
                            }}
                        />
                        <DKInput
                            value={[compliancePeriods.findIndex(c=>c.id=== employeeData['compensationPeriod'])]}
                            title="Period"
                            type={INPUT_TYPE.SELECT}
                            showError={false}
                            direction={INPUT_VIEW_DIRECTION.VERTICAL}
                            required={false}
                            canValidate={false}
                            options={periodType}
                            onChange={(value) => {
                                setEmpployeeData({ ...employeeData, compensationPeriod: compliancePeriods[value[0]].id })
                            }}
                        />
                    </div>
                }
            </div>
        </div>
    )
}

export default ShowAddEmployeePopup
